export { default as getData } from './getData';
